import type { Poste } from "models";
import { useState, useEffect } from "react";
import { postesService } from "services";
import { useSnackbarErrorHandler } from "utils/errorHandling";
import { sortingUtil } from "utils";

interface IUsePoste {
  postes: Array<Poste>;
  isPostesLoading: boolean;
}

/**
 * Cherche et retourne la liste de tous les postes, pré-rangés.
 * @returns `{ postes, isPostesLoading }`
 */
export function usePostes(): IUsePoste {
  const [postes, setPostes] = useState<Array<Poste>>([]);
  const { catchErrors: catchPostesErrors, isLoading: isPostesLoading } = useSnackbarErrorHandler();

  useEffect(() => {
    async function getPostes(): Promise<void> {
      const _postes = await postesService.getAll();
      _postes.sort(sortingUtil.sortPostes);
      setPostes(_postes);
    }
    void catchPostesErrors(getPostes);
  }, [catchPostesErrors]);

  return { postes, isPostesLoading };
}
